import {getAppSpecs} from '@cohort/shared/schema/apps';
import {AuthComponent} from '@cohort/wallet/apps/AuthComponent';

export const AppsConnectionSettings: React.FC = () => {
  return (
    <div className="flex flex-col">
      {getAppSpecs().map(
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        appSpec => appSpec.userConnector && <AuthComponent key={appSpec.id} appSpec={appSpec} />
      )}
    </div>
  );
};
